import angular from 'angular';
import template from './desktop-frame-menu.html';
import './desktop-frame-menu.scss';
class CallFramesDesktopFrameMenuController {
    constructor() { }
}
const callFramesDesktopFrameMenu = {
    template,
    bindings: {
        items: '<',
    },
    controller: CallFramesDesktopFrameMenuController,
};
export default angular
    .module('doxy.videoChat.callFrames.desktopFrameMenu', [])
    // call-frames-desktop-frame-menu
    .component('callFramesDesktopFrameMenu', callFramesDesktopFrameMenu).name;
